import { calcAverage, calcMax, calcMin, calcQuantile, calcSum } from './statistics';

interface TpNumericalAggregator {
  id: string;
  displayName: string;
  isAdditive: boolean;
  perform: (input: number[]) => number;
}

export const numericalAggregatorList: TpNumericalAggregator[] = [];

export function notZeroValue(value: number): boolean {
  return Math.abs(value) > 1e-99;
}

export function getNumericalAggregator(id: string): TpNumericalAggregator {
  const aggregrator = numericalAggregatorList.find((agg) => agg.id == id);
  if (!aggregrator) throw `Invalid aggregator: ${id}`;
  return aggregrator;
}

numericalAggregatorList.push({
  id: 'numericalAggregatorSum',
  displayName: 'Sum',
  isAdditive: true,
  perform: calcSum,
});

numericalAggregatorList.push({
  id: 'numericalAggregatorAverage',
  displayName: 'Average',
  isAdditive: true,
  perform: calcAverage,
});

numericalAggregatorList.push({
  id: 'numericalAggregatorAverageNonzero',
  displayName: 'Average of non-zero',
  isAdditive: true,
  perform: (input: number[]) => {
    const filtered = input.filter((val) => notZeroValue(val));
    return calcAverage(filtered);
  },
});

numericalAggregatorList.push({
  id: 'numericalAggregatorMedian',
  displayName: 'Median',
  isAdditive: true,
  perform: (input: number[]) => calcQuantile(input, 0.5),
});

numericalAggregatorList.push({
  id: 'numericalAggregatorMedianNonzero',
  displayName: 'Median of non-zero',
  isAdditive: true,
  perform: (input: number[]) =>
    calcQuantile(
      input.filter((val) => notZeroValue(val)),
      0.5,
    ),
});

numericalAggregatorList.push({
  id: 'numericalAggregatorMin',
  displayName: 'Minimum',
  isAdditive: true,
  perform: calcMin,
});

numericalAggregatorList.push({
  id: 'numericalAggregatorMax',
  displayName: 'Maximum',
  isAdditive: true,
  perform: calcMax,
});

numericalAggregatorList.push({
  id: 'numericalAggregatorNonzeroCount',
  displayName: 'Number of non-zero values',
  isAdditive: true,
  perform: (input: number[]) => input.filter((val) => notZeroValue(val)).length,
});

numericalAggregatorList.push({
  id: 'numericalAggregatorNonzeroFraction',
  displayName: 'Fraction of non-zero values',
  isAdditive: true,
  perform: (input: number[]) => {
    if (input.length == 0) return NaN;
    return input.filter((val) => notZeroValue(val)).length / input.length;
  },
});
